import { render, staticRenderFns } from "./comparisonResult.vue?vue&type=template&id=b6b01adc&"
import script from "./comparisonResult.vue?vue&type=script&lang=js&"
export * from "./comparisonResult.vue?vue&type=script&lang=js&"
import style0 from "./comparisonResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports